export { MultiSelect } from "@mantine/core";
export type { MultiSelectProps } from "@mantine/core";
export { getMultiSelectOverrides } from "./MultiSelect.styled";
